import Vue from 'vue'
import * as moment from 'moment'
import { OrderStatusIdentifier, OrderTab, PaymentSummary } from '../utils/enums/order-enums'
import { PromotionTypeTab, PromotionStateTab, PromotionType, PromotionRuleType, CustomerRoleToOption } from '../utils/enums/promotion-enums'
import { StatusState } from '../utils/enums/status-enum'
import { GiftCardStateTab } from '../utils/enums/giftcard-enums'
import { ShippingMethodIdentifierEnum, ShippingMethodTypeEnum } from '../utils/enums/shipping-enums'
import { TaxExemptStatus } from '../utils/enums/tax-enums'
import { TenantNameMap } from '../utils/helpers'

Vue.filter('formatDate', function (value, format = 'MM/DD/YYYY') {
  if (value) {
    if (value instanceof moment) {
      return value.format(format)
    }
    return moment(String(value)).format(format)
  }
})

Vue.filter('formatUtcDate', function (value, format = 'MM/DD/YYYY') {
  if (value) {
    if (value.length && value[value.length - 1] === 'Z') {
      return moment(String(value)).format(format)
    }
    return moment(`${value}Z`).format(format)
  }
})

Vue.filter('formatUtcTime', function (value, format = 'h:mma') {
  if (value) {
    if (value.length && value[value.length - 1] === 'Z') {
      return moment(String(value)).format(format)
    }
    return moment(`${value}Z`).format(format)
  }
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

// Available sizes in pixel width (Height will vary due to maintaining aspect)
// 'XS' - 100
// 'S' - 200
// 'M' - 400
// 'L' - 600
// 'XL' - 800
// 'O' (Original)
Vue.filter('fullImagePath', function (value, size) {
  if (!value) {
    return null
  }
  if (value.startsWith('http')) {
    return value
  }
  size = size || 'L'
  return process.env.VUE_APP_CDN_URL + value + size + '.png'
})

Vue.filter('filePath', function (value) {
  if (!value) {
    return null
  }
  return process.env.VUE_APP_CDN_URL + value
})

Vue.filter('orderStatus', function (value) {
  if (value) {
    const key = Object.keys(OrderStatusIdentifier)[value - 1] // Get the status value (eg. CancelRequested)
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed (eg. Cancel Requested)
  }
})

Vue.filter('formatShippingMethod', function (value) {
  if (value) {
    const key = Object.keys(ShippingMethodIdentifierEnum)[value - 1] // Get the status value (eg. CancelRequested)
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed (eg. Cancel Requested)
  }
})

Vue.filter('ExamRequestStatus', function (value) {
  if (value) {
    const key = Object.keys(StatusState)[value - 1] // Get the status value (eg. CancelRequested)
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed (eg. Cancel Requested)
  }
})

Vue.filter('taxExemptStatus', function (value) {
  if (value) {
    const key = Object.keys(TaxExemptStatus)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('shippingMethodType', function (value) {
  if (value >= 0) {
    const key = Object.keys(ShippingMethodTypeEnum)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('paymentSummary', function (value) {
  if (value >= 0) {
    const key = Object.keys(PaymentSummary)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('orderTab', function (value) {
  if (value >= 0) {
    const key = Object.keys(OrderTab)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('promoTypeTab', function (value) {
  if (value >= 0) {
    const key = Object.keys(PromotionTypeTab)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('promoStateTab', function (value) {
  if (value >= 0) {
    const key = Object.keys(PromotionStateTab)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('giftCardStateTab', function (value) {
  if (value >= 0) {
    const key = Object.keys(GiftCardStateTab)[value] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('promoType', function (value) {
  if (value >= 1) {
    const key = Object.keys(PromotionType)[value - 1] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('promoRuleType', function (value) {
  if (value >= 1) {
    const key = Object.keys(PromotionRuleType)[value - 1] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('customerRoleType', function (value) {
  if (value >= 1) {
    const key = Object.keys(CustomerRoleToOption)[value - 1] // Get the value
    return key.replace(/([A-Z])/g, ' $1') // Add spaces as needed
  }
})

Vue.filter('formatBoolean', function (value) {
  return value ? 'Yes' : 'No'
})

Vue.filter('tenantName', function (tenantId) {
  return TenantNameMap[tenantId]
})
